import { EnrolledDevice } from '@zero/shared/util-models';
import { PreAuthorizedBaseData } from './pre-authorized-base-data';

export class PreAuthorizationSessionAuth extends PreAuthorizedBaseData {
  public static typename = 'PreAuthorizationSessionAuth';

  public verifiedPhoneNumber: string;
  public enrolledTANDevices: EnrolledDevice[];

  constructor(
    type: string,
    hash: string,
    customerId: string,
    username: string,
    verifiedPhoneNumber: string,
    enrolledTANDevices: EnrolledDevice[],
  ) {
    super(type, hash, customerId, username);
    this.verifiedPhoneNumber = verifiedPhoneNumber;
    this.enrolledTANDevices = enrolledTANDevices;
  }

  public getTypename(): string {
    return PreAuthorizationSessionAuth.typename;
  }
}
